import { useEffect, useMemo, useState } from "react";
import { usePermissions } from "react-admin";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import config from "../config/config";

const dialogSessionKey = "affiliate_survey_dialog_dismissed";

const AffiliateSurveyDialog = () => {
  const { isPending, permissions } = usePermissions();
  const [open, setOpen] = useState(false);
  const surveyConfig = useMemo(() => config.affiliate_survey || {}, []);

  useEffect(() => {
    if (isPending) return;

    const isCustomer = permissions === "admin-customer";
    const isEnabled = Boolean(surveyConfig.enabled);
    const alreadyDismissed = sessionStorage.getItem(dialogSessionKey) === "1";

    setOpen(isCustomer && isEnabled && !alreadyDismissed);
  }, [isPending, permissions, surveyConfig.enabled]);

  const handleClose = () => {
    sessionStorage.setItem(dialogSessionKey, "1");
    setOpen(false);
  };

  const handleSurveyClick = () => {
    window.open(surveyConfig.url, "_blank", "noopener,noreferrer");
    handleClose();
  };

  if (!surveyConfig.url) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{surveyConfig.title}</DialogTitle>
      <DialogContent>
        {/* <Typography>{surveyConfig.message}</Typography> */}
        <div dangerouslySetInnerHTML={{ __html: surveyConfig.message }} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSurveyClick}>
          {surveyConfig.button_label}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AffiliateSurveyDialog;
